import { Injectable } from '@angular/core';
import { CanLoad, Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { EndpointsConfigService } from '../services/endpoints-config.service';

@Injectable()
export class EndpointsConfigGuard implements CanLoad {

    constructor(private readonly endpointsConfigService: EndpointsConfigService,
                private readonly router: Router) {
    }

    async canLoad(route: Route, segments: UrlSegment[]): Promise<boolean | UrlTree> {
        try {
            const config = await lastValueFrom(this.endpointsConfigService.getClientEnvironmentConfig());
            if (!config) {
                throw new Error('Could not get endpoints configuration');
            }

            return true;
        } catch (e) {
            console.error(e);
            return this.router.parseUrl('access-denied');
        }
    }
}
